<!-- Background Decorative Blobs -->
<div class="bg-blobs">
  <div class="blob-1"></div>
  <div class="blob-2"></div>
</div>

<div class="main-content">
  
  <!-- ─── Welcome / Onboarding View ────────────────────────────────────────── -->
  <ng-container *ngIf="!auth.business?.id">
    
    <!-- Language Selector -->
    <div class="language-selector">
      <button class="lang-btn" (click)="changeLang(selectedLang === 'en' ? 'hi' : 'en')">
        <span class="material-icons">language</span>
        <span>{{ selectedLang === 'en' ? 'English' : 'Hindi' }}</span>
        <span class="material-icons">expand_more</span>
      </button>
    </div>

    <!-- Logo Section -->
    <div class="logo-section">
      <div class="logo-wrapper">
        <img src="assets/icon/favicon.png" alt="Vanshavali Logo">
      </div>
      <div class="logo-glow"></div>
    </div>

    <!-- Hero Text -->
    <header>
      <h1 class="hero-title">{{ 'Welcome to Vanshavali' | translate }}</h1>
      <p class="hero-tagline">
        {{ 'Let’s build stronger connections, celebrate our roots, and grow as one family.' | translate }}
      </p>
    </header>

    <!-- Main Actions -->
    <div class="actions-container">
      
      <!-- Primary Action: Create -->
      <div class="primary-action">
        <ion-button class="create-btn" expand="block" (click)="createYourFamilyTree()">
          <span class="material-icons" style="margin-right: 12px;">account_tree</span>
          {{ 'Create Family Tree' | translate }}
        </ion-button>
        <p class="btn-hint">{{ 'Begin your legacy today' | translate }}</p>
      </div>

      <!-- Divider -->
      <div class="divider">
        <div class="line"></div>
        <span class="text">{{ 'or' | translate }}</span>
        <div class="line"></div>
      </div>

      <!-- Invite Section -->
      <div class="join-section">
        <label class="section-label">
          <span class="material-icons">group_add</span>
          {{ 'Join an existing tree' | translate }}
        </label>
        
        <div class="input-group">
          <ion-input 
            class="invite-input" 
            [(ngModel)]="inviteLink" 
            placeholder="{{ 'Paste your invite link here' | translate }}"
            (keyup.enter)="onSearchEnter($event)">
          </ion-input>
          <ion-button class="ok-btn" (click)="onSearchEnter(inviteLink)">
            {{ 'OK' | translate }}
          </ion-button>
        </div>

        <p class="section-hint">
          {{ 'Received a link from a family member? Enter it above to connect instantly.' | translate }}
        </p>
      </div>
    </div>
  </ng-container>

  <!-- ─── Business / Community Profile View ─────────────────────────────────── -->
  <ng-container *ngIf="auth.business?.id">
    <div class="business-profile">
      
      <!-- Profile Header -->
      <div class="biz-logo-wrapper" *ngIf="auth.business.logo">
        <img class="biz-logo" [src]="auth.business.logo">
      </div>

      <h2 class="biz-name">{{ auth.business.name }}</h2>
      <p class="biz-slogan">{{ auth.business.slogan }}</p>

      <div class="welcome-msg">
        {{ 'Welcome to the' | translate }} <b>{{ auth.business.name }}</b>. 
        {{ 'We are delighted to have you with us-together, lets build stronger connections.' | translate }}
      </div>

      <!-- Selection Dropdown -->
      <div class="selection-container" *ngIf="auth.business.category">
        <app-a-select 
          [label]="trans.translate('Sub Community/Gotra/Khap/Pur')"
          (variableChange)="onCommunityChange($event)" 
          [(variable)]="auth.subCommunity"
          [objectList]="auth.business.category">
        </app-a-select>
      </div>

      <!-- Actions -->
      <button class="change-community-link" (click)="clickChangeCommunity()">
        {{ 'Change Your community name' | translate }}
      </button>

    </div>
  </ng-container>

  <!-- Global Footer -->
  <footer class="footer-info">
    <div class="footer-links">
      <a href="#">{{ 'Privacy Heritage' | translate }}</a>
      <span class="dot"></span>
      <a href="#">{{ 'Archive Terms' | translate }}</a>
    </div>
    <div class="version-tag" (click)="clickVersion()">
      Version: <span class="v-val">{{ envName }} - {{ version }}</span>
    </div>
  </footer>

</div>

<!-- Visual Texture Overlay -->
<div class="paper-overlay"></div>